const roleTypes = {
  REFERENCE_DATA: "REFERENCE_DATA",
  REFERENCE_DATA_SUCCESS: "REFERENCE_DATA_SUCCESS",
  ROLE_LIST: "ROLE_LIST",
  ROLE_LIST_SUCCESS: "ROLE_LIST_SUCCESS",
  ROLE_LIST_RESET: "ROLE_LIST_RESET",
  ADD_ROLE: "ADD_ROLE",
  ADD_ROLE_SUCCESS: "ADD_ROLE_SUCCESS",
  UPDATE_ROLE: "UPDATE_ROLE",
  UPDATE_ROLE_SUCCESS: "UPDATE_ROLE_SUCCESS",
  DELETE_ROLE: "DELETE_ROLE",
  DELETE_ROLE_SUCCESS: "DELETE_ROLE_SUCCESS",
  INVITE_LIST: "INVITE_LIST",
  INVITE_LIST_SUCCESS: "INVITE_LIST_SUCCESS",
  INVITE_LIST_RESET: "INVITE_LIST_RESET",
  ADD_INVITE: "ADD_INVITE",
  ADD_INVITE_SUCCESS: "ADD_INVITE_SUCCESS",
  UPDATE_INVITE: "UPDATE_INVITE",
  UPDATE_INVITE_SUCCESS: "UPDATE_INVITE_SUCCESS",
  DELETE_INVITE: "DELETE_INVITE",
  DELETE_INVITE_SUCCESS: "DELETE_INVITE_SUCCESS",
  SEND_INVTE_REMINDER: "SEND_INVTE_REMINDER",
  SEND_INVTE_REMINDER_SUCCESS: "SEND_INVTE_REMINDER_SUCCESS",
  EXTEND_EXPIRATION_DATA: " EXTEND_EXPIRATION_DATA",
  EXTEND_EXPIRATION_DATA_SUCCESS: " EXTEND_EXPIRATION_DATA_SUCCESS",
  ROLE_DETAILS: "ROLE_DETAILS",
  ROLE_DETAILS_SUCCESS: "ROLE_DETAILS_SUCCESS",
  CANDIDATE_INVITE: "CANDIDATE_INVITE",
  CANDIDATE_INVITE_SUCCESS: "CANDIDATE_INVITE_SUCCESS",
  GENERATE_PROFILE: "GENERATE_PROFILE",
  GENERATE_PROFILE_SUCCESS: "GENERATE_PROFILE_SUCCESS",
  INVITE_CANDIDATE_DETAILS: "INVITE_CANDIDATE_DETAILS",
  INVITE_CANDIDATE_DETAILS_SUCCESS: "INVITE_CANDIDATE_DETAILS_SUCCESS",
  DETAIL_INVITE_CANDIDATE: " DETAIL_INVITE_CANDIDATE",
  DETAIL_INVITE_CANDIDATE_SUCCESS: " DETAIL_INVITE_CANDIDATE_SUCCESS",
  FILTER_ROLE: "FILTER_ROLE",
  FILTER_ROLE_SUCCESS: "FILTER_ROLE_SUCCESS",
  ROLE_STATUS: "ROLE_STATUS",
  ROLE_STATUS_SUCCESS: "ROLE_STATUS_SUCCESS",
  ROLE_TOTAL_COUNT: "ROLE_TOTAL_COUNT",
  ROLE_MY_COUNT: "ROLE_MY_COUNT",
  ROLE_ALL_COUNT: "ROLE_ALL_COUNT",
  INVITE_FILTER: "INVITE_FILTER",
  INVITE_FILTER_SUCCESS: "INVITE_FILTER_SUCCESS",
  INVITE_DETAILS: "INVITE_DETAILS",
  INVITE_DETAILS_SUCCESS: "INVITE_DETAILS_SUCCESS",
  INVITE_DETAILS_FAILURE: "INVITE_DETAILS_FAILURE",
  INVITE_TOTAL_COUNT: "INVITE_TOTAL_COUNT",
  INVITE_MY_COUNT: "INVITE_MY_COUNT",
  INVITE_ALL_COUNT: "INVITE_ALL_COUNT",
  ROLE_GENERATE_SKILL: "ROLE_GENERATE_SKILL",
  ROLE_GENERATE_SKILL_SUCCESS: "ROLE_GENERATE_SKILL_SUCCESS",
  INVITE_STATUS: "INVITE_STATUS",
  INVITE_STATUS_SUCCESS: "INVITE_STATUS_SUCCESS",
  ROLESKILL_MATCHING: "ROLESKILL_MATCHING",
  ROLESKILL_MATCHING_SUCCESS: "ROLESKILL_MATCHING_SUCCESS",
  RESET_TEST: "RESET_TEST",
  RESET_TEST_SUCCESS: "RESET_TEST_SUCCESS",
  DOWNLOAD_CR: "DOWNLOAD_CR",
  DOWNLOAD_CR_SUCCESS: "DOWNLOAD_CR_SUCCESS",
  EXTEND_EXPIRATION_RESET: "EXTEND_EXPIRATION_RESET",
  DOWNLOAD_REPORT_STATUS: "DOWNLOAD_REPORT_STATUS",
  CANDIDATE_PROFILE: "CANDIDATE_PROFILE",
  CANDIDATE_PROFILE_SUCCESS: "CANDIDATE_PROFILE_SUCCESS",
  CANDIDATE_PROFILE_FAILURE: "CANDIDATE_PROFILE_FAILURE",
  CANDIDATE_JOB_SPECIFIC_PROFILE: "CANDIDATE_JOB_SPECIFIC_PROFILE",
  CANDIDATE_JOB_SPECIFIC_PROFILE_SUCCESS: "CANDIDATE_JOB_SPECIFIC_PROFILE_SUCCESS",
  CANDIDATE_JOB_SPECIFIC_PROFILE_FAILURE: "CANDIDATE_JOB_SPECIFIC_PROFILE_FAILURE",
  UPDATE_TIMELINE_EVENTS: "UPDATE_TIMELINE_EVENTS",
  UPDATE_TIMELINE_EVENTS_SUCCESS: "UPDATE_TIMELINE_EVENTS_SUCCESS",
  UPDATE_TIMELINE_EVENTS_FAILURE: "UPDATE_TIMELINE_EVENTS_FAILURE",
  CLEAR_UPDATE_TIMELINE_EVENTS: "CLEAR_UPDATE_TIMELINE_EVENTS",
  CANDIDATE_PROFILE_REPORT: "CANDIDATE_PROFILE_REPORT",
  CANDIDATE_PROFILE_REPORT_SUCCESS: "CANDIDATE_PROFILE_REPORT_SUCCESS",
  CANDIDATE_PROFILE_REPORT_FAILURE: "CANDIDATE_PROFILE_REPORT_FAILURE",
  PROFILE_MATCH_REPORT: "PROFILE_MATCH_REPORT",
  PROFILE_MATCH_REPORT_SUCCESS: "PROFILE_MATCH_REPORT_SUCCESS",
  PROFILE_MATCH_REPORT_FAILURE: "PROFILE_MATCH_REPORT_FAILURE",
  GET_QUES_ANS_BY_TRACKING_ID: "GET_QUES_ANS_BY_TRACKING_ID",
  GET_QUES_ANS_BY_TRACKING_ID_SUCCESS: "GET_QUES_ANS_BY_TRACKING_ID_SUCCESS",
  GET_QUES_ANS_BY_TRACKING_ID_FAILURE: "GET_QUES_ANS_BY_TRACKING_ID_FAILURE",
  CODING_SUBMISSION_DETAILS: "CODING_SUBMISSION_DETAILS",
  CODING_SUBMISSION_DETAILS_SUCCESS: "CODING_SUBMISSION_DETAILS_SUCCESS",
  CODING_SUBMISSION_DETAILS_FAILURE: "CODING_SUBMISSION_DETAILS_FAILURE",
  GET_BEHAVIOR_SKILLS: "GET_BEHAVIOR_SKILLS",
  GET_BEHAVIOR_SKILLS_SUCCESS: "GET_BEHAVIOR_SKILLS_SUCCESS",
  GET_BEHAVIOR_SKILLS_FAILURE: "GET_BEHAVIOR_SKILLS_FAILURE",
};
export default roleTypes;
